import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "footer.md"
        }}>{`footer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h1.md"
        }}>{`h1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h2.md"
        }}>{`h2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h3.md"
        }}>{`h3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h4.md"
        }}>{`h4`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h5.md"
        }}>{`h5`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "h6.md"
        }}>{`h6`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "hr.md"
        }}>{`hr`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      